if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.tabButtons = Array.from(this.querySelectorAll('[data-tab-target]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

        this.tabButtons.forEach((button) => {
          button.addEventListener('click', () => this.switchTab(button));
        });
      }

      switchTab(activeButton) {
        const target = activeButton.getAttribute('data-tab-target');

        this.tabButtons.forEach((button) => {
          const isActive = button === activeButton;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          const isActive = panel.getAttribute('data-tab-panel') === target;
          panel.classList.toggle('is-active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }
    }
  );
}
